<div class="warp-sign">
    <p translate>questionBoard.edit.signature</p>
    <div class="wrapper">
        <div class="canavas-warp">
        <canvas class="canavas" #signPadCanvas [width]="600" [height]="100"
            [style.pointer-events]="isNotUser$() ? 'none' : 'auto'"> </canvas>
        </div>
        <div class="btns">
            <button class="btn btn-warning pointer" (click)="isNotUser$()?null:undoSign()">
                <img src="/assets/images/delete.svg">
            </button>
        </div>
    </div>
    <div class="warp-active-toggle" *ngIf="isDisplay && question?.isIncludeDate">
        <p translate>questionBoard.edit.signatureDate</p>:
        <p>{{sigbatureDate$() | queDate}}</p>
    </div>
</div>